import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import withMemo from '../../decorators/withMemo';
import { mergeStyles } from '../../utils/StyleUtils';
import A from '../A';
import Icon from '../Icon';
import icons from '../Icon/icons';
import styles from './styles';
var useStyles = createUseStyles(styles);
var Header = function Header(props) {
  var classesProp = props.classes,
    className = props.className,
    texts = props.texts,
    isLogged = props.isLogged,
    homePageLinkProps = props.homePageLinkProps,
    loginLinkProps = props.loginLinkProps,
    logoutLinkProps = props.logoutLinkProps;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  return /*#__PURE__*/React.createElement("header", {
    className: cx(classes.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(A, _extends({}, homePageLinkProps, {
    className: classes.title,
    "aria-label": "".concat(texts == null ? void 0 : texts.powered, " ").concat(texts == null ? void 0 : texts.title)
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: icons.Logo
  })), /*#__PURE__*/React.createElement("nav", {
    className: classes.login
  }, isLogged ? /*#__PURE__*/React.createElement(A, logoutLinkProps, texts == null ? void 0 : texts.logout) : /*#__PURE__*/React.createElement(A, loginLinkProps, texts == null ? void 0 : texts.login))));
};
Header.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  texts: PropTypes.any,
  isLogged: PropTypes.any,
  homePageLinkProps: PropTypes.any,
  loginLinkProps: PropTypes.any,
  logoutLinkProps: PropTypes.any
};
Header.defaultProps = {
  className: null,
  classes: null,
  texts: null,
  isLogged: null,
  homePageLinkProps: null,
  loginLinkProps: null,
  logoutLinkProps: null
};
export default withMemo()(Header);